var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0004 11H7.40039L12.7004 5.7C13.1004 5.3 13.1004 4.7 12.7004 4.3C12.3004 3.9 11.7004 3.9 11.3004 4.3L4.30039 11.3C4.20039 11.4 4.10039 11.5 4.10039 11.6C4.00039 11.8 4.00039 12.1 4.10039 12.4C4.20039 12.5 4.20039 12.6 4.30039 12.7L11.3004 19.7C11.5004 19.9 11.8004 20 12.0004 20C12.2004 20 12.5004 19.9 12.7004 19.7C13.1004 19.3 13.1004 18.7 12.7004 18.3L7.40039 13H19.0004C19.6004 13 20.0004 12.6 20.0004 12C20.0004 11.4 19.6004 11 19.0004 11Z",
    fill: "#D91F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftRed);
export default __webpack_public_path__ + "static/media/arrowLeftRed.06ebfb0c42afe265005e1f2f7700b787.svg";
export { ForwardRef as ReactComponent };